import "./htmx"
import htmx from "htmx.org"

import { JoystickManager } from "nipplejs"
import { initController } from "./game/Controller"
import {
  WebSocketManager,
  WebSocketManagerOptions,
  initWebSocket,
} from "./game/WebSocketManager"
import { initGame } from "./game/main"
import Game from "./game/Game"
import { v4 } from "uuid"
import { GameMessage } from "src/common/networkingHelper"
import { AccountStatus, Chain, Token, initTipView, onChainBack, onChainSubmit, onTipAmountBack, onTipAmountSubmit, onTokenSubmit } from "./tip"
import { Web3Modal } from "@web3modal/wagmi"
import { initWithdrawView, onWithdrawSubmit } from "./withdraw"
import { PlayerId, PlayerImages } from "$types/index"

declare global {
  interface Window {
    htmx: typeof htmx
    controller: JoystickManager | undefined

    initGame: (
      ws: WebSocketManager,
      assets: { tileset: string }
    ) => Promise<Game>
    initController: (playerId: PlayerId, ws: WebSocketManager, images: PlayerImages ) => void
    initWebSocket(
      path: string,
      options?: WebSocketManagerOptions
    ): WebSocketManager

    checkOrientation: () => void
    requestFullScreen: () => void

    game: Game | undefined
    getUserId: () => string
    disableDoubleTapZoom: () => void
    getUserIdFromQueryStringOrRedirect: () => string | null
    ws: WebSocketManager | undefined
    listenPrizeUpdates: () => void,
    startFireworks: (duration?: number) => void
    stopFireworks: () => void

    tipData: {
      accountStatus: AccountStatus
      receiverAddress: `0x${string}`
      gameId: string
      userId: string
      token: Token
      chain: Chain
      tipAmount: number
    }
    web3Modal: Web3Modal | null

    initTipView: (gameId: string, userId: string, address: `0x${string}`) => void

    onTokenSubmit: (event: SubmitEvent) => void
    onChainBack: () => void
    onChainSubmit: (event: SubmitEvent) => void
    onTipAmountBack: () => void
    onTipAmountSubmit: (event: SubmitEvent) => void

    withdrawData: {
      gameId: string
      userId: string
      loading: boolean
    }
    initWithdrawView: (gameId: string, userId: string) => void
    onWithdrawSubmit: (event: SubmitEvent) => void

    removeError: (event: MouseEvent) => void
  }
}

window.initGame = initGame
window.initController = initController
window.initWebSocket = initWebSocket

window.initTipView = initTipView
window.onTokenSubmit = onTokenSubmit
window.onChainBack = onChainBack
window.onChainSubmit = onChainSubmit
window.onTipAmountBack = onTipAmountBack
window.onTipAmountSubmit = onTipAmountSubmit

window.initWithdrawView = initWithdrawView
window.onWithdrawSubmit = onWithdrawSubmit

window.removeError = (event: MouseEvent): void => {
  const container = (event.target as HTMLElement).closest(".error")
  container?.remove()
}

window.checkOrientation = () => {
  const orientation =
    window.innerWidth >= window.innerHeight ? "landscape" : "portrait"
  document
    .getElementById("orientation-banner")
    ?.classList.toggle("visible", orientation === "portrait")
}

window.requestFullScreen = () => {
  // try {
  //   const elem = document.documentElement
  //   if (elem.requestFullscreen) {
  //     elem.requestFullscreen()
  //     // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   } else if ((elem as any).webkitRequestFullscreen) {
  //     // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //     void (elem as any).webkitRequestFullscreen()
  //   }
  // } catch (e) {
  //   console.warn(e)
  // }
}

window.addEventListener("load", () => {
  window.checkOrientation()
  window.addEventListener("orientationchange", () => {
    window.checkOrientation()
  })
  window.addEventListener("resize", () => {
    window.checkOrientation()
  })
})

window.getUserId = () => {
  if (localStorage.getItem("userId")) {
    return localStorage.getItem("userId")!
  } else {
    const userId = v4().split("-")[0]
    localStorage.setItem("userId", userId)
    return userId
  }
}

window.disableDoubleTapZoom = () => {
  document.body.addEventListener("click", (event) => {
    event.preventDefault()
  })
}

window.getUserIdFromQueryStringOrRedirect = (): string | null => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  let userId = urlSearchParams.get("userId")

  if (!userId) {
    userId = window.getUserId()
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set("userId", userId)
    window.location.href = newUrl.href
    return null
  }

  return userId
}

window.listenPrizeUpdates = () => {
  const { ws } = window
  const prize = document.getElementById("prize")
  const totalPrize = document.getElementById("total-prize")
  if (ws && prize) {
    ws.onmessage.push(({ data }) => {
      if (data.byteLength === 1) return
      const event = JSON.parse(data) as GameMessage
      if (event.type === "TIP_ADDED") {
        prize.innerHTML = event.prize.toString()
        if (totalPrize) {
          totalPrize.innerHTML = event.prize.toString()
        }

        document.body.classList.add("is-tip")
      }
    })
  } else {
    throw new Error("WebSocketManager not initialized")
  }
}

window.startFireworks = (duration?: number) => {
  document.body.classList.add("fireworks")
  if (duration) {
    setTimeout(() => {
      window.stopFireworks()
    }, duration)
  }
}

window.stopFireworks = () => {
  document.body.classList.remove("fireworks")
}
